import { onwardBookingData } from "../../../components/KSRTC/Booking/AdvanceTicketBooking/AdvTicketConstant";
import { onwardBlockSeat } from "../../../components/KSRTC/Booking/BlockSeat/BlockSeatConstant";
import { returnObj } from "../../../components/KSRTC/Booking/CurrentBooking/CurrentBookingConstant";
import * as types from "./bookingActionType";
const initialState = {
	CityList: [],
	countryList: [],
	paymentModaList: [],
	ownardTicketData: onwardBookingData,
	BusList: [],
	TripSheetTableData: [],
	TripListAll: [],
	owardBlockData: onwardBlockSeat,
	blockSeatList: [],
	ticketNumber: 0,
	branchsList: {},
	cancelReqType: [],
	ownardCurrrentTicketData: returnObj,
	stockCounter: {},
	advanceOwnerDiscount: [],
	advanceReturnDiscount: [],
	currentOwnerDiscount: [],
	currentReturnDiscount: [],
	classTypeList: [],
	idTypeList: [],
	manifestDetails: {},
	cargoVehicleDetails: [],
	cargoDriverCundotuerList: [],
	cargoDispatch: false,
	PPRRunningNo: 0,
	startingFrom: [],
	accoTypeList: [],
	variantDataList: [],
	CargoBalance: 0,
	KSTDCCityList: []

};
const BookingReducer = (state = initialState, action) => {
	switch (action.type) {
		case types.CITY_LIST:
			return {
				...state,
				CityList: action.payload,
			};
		case types.COUNTRY_LIST:
			return {
				...state,
				countryList: action.payload,
			};
		case types.PAYMENT_MODA_LIST:
			return {
				...state,
				paymentModaList: action.payload,
			};
		case types.OWNARD_TICKET_DATA:
			return {
				...state,
				ownardTicketData: {
					...state.ownardTicketData,
					...action.payload,
				},
			};
		case types.BUS_LIST:
			return {
				...state,
				BusList: action.payload || [],
			};

		case types.TRIP_SHEET_TABLE_DATA:
			return {
				...state,
				TripSheetTableData: action.payload || [],
			};
		case types.TRIP_LIST_ALL:
			return {
				...state,
				TripListAll: action.payload || [],
			};
		case types.BRANCHES_LIST:
			return {
				...state,
				branchsList: action.payload,
			};
		case types.UPDATE_TICKET_NUMBER:
			return {
				...state,
				ticketNumber: action.payload,
			};
		case types.CAN_REQ_LIST:
			return {
				...state,
				cancelReqType: action.payload,
			};
		case types.UPDATE_ONWARD_BLOCK:
			return {
				...state,
				owardBlockData: { ...state.owardBlockData, ...action.payload },
			};
		case types.UPDATE_BLOCKSEAT_LIST:
			return {
				...state,
				blockSeatList: action.payload,
			};
		case types.OWNARD_CURRENT_TICKET_DATA:
			return {
				...state,
				ownardCurrrentTicketData: {
					...state.ownardCurrrentTicketData,
					...action.payload,
				},
			};
		case types.UPDATE_STOCK_COUNTER:
			return {
				...state,
				stockCounter: action.payload,
			};
		case types.UPDATE_ADVOWARD_DISCOUNT:
			return {
				...state,
				advanceOwnerDiscount: action.payload,
			};
		case types.UPDATE_ADVORETURN_DISCOUNT:
			return {
				...state,
				advanceReturnDiscount: action.payload,
			};
		case types.UPDATE_CURROWARD_DISCOUNT:
			return {
				...state,
				currentOwnerDiscount: action.payload,
			};
		case types.UPDATE_CURRRETURN_DISCOUNT:
			return {
				...state,
				currentReturnDiscount: action.payload,
			};
		case types.UPDATE_CLASS_TYPE_LIST:
			return {
				...state,
				classTypeList: action.payload,
			};
		case types.UPDATE_ID_TYPE_LIST:
			return {
				...state,
				idTypeList: action.payload,
			};
		case types.MANIFEST_DETAILS:
			return {
				...state,
				manifestDetails: action.payload,
			};
		case types.CARGO_VEHICLE_DETAILS:
			return { ...state, cargoVehicleDetails: action.payload };
		case types.DRIVER_CONDUCTOR_LIST_ALL:
			return {
				...state,
				cargoDriverCundotuerList: action.payload,
			};
		case types.CARGO_DISATCH:
			return {
				...state,
				cargoDispatch: action.payload,
			};
		case types.ISSUE_CARGO_PPR:
			return {
				...state,
				PPRRunningNo: action.payload,
			};
		case types.UPDATE_STARTING_FROM:
			return {
				...state,
				startingFrom: action.payload
			}
		case types.UPDATE_ACCO_TYPE:
			return {
				...state,
				accoTypeList: action.payload
			}
		case types?.UPDATE_VARIANT_DATA:
			return {
				...state,
				variantDataList: action.payload
			}
		case types.ISSUE_CARGO_BALANCE:
			return {
				...state,
				CargoBalance: action.payload,
			};
		case types?.KSTDC_CITY_LIST:
			return {
				...state,
				KSTDCCityList: action.payload
			}
		default:
			return state;
	}
};

export default BookingReducer;
